import { render, staticRenderFns } from "./MedicineRecallRecord.vue?vue&type=template&id=73cd32d1&scoped=true&"
import script from "./MedicineRecallRecord.vue?vue&type=script&lang=js&"
export * from "./MedicineRecallRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cd32d1",
  null
  
)

export default component.exports